import { render, staticRenderFns } from "./Resort.vue?vue&type=template&id=51d05319"
import script from "./Resort.vue?vue&type=script&lang=js"
export * from "./Resort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports